import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons/faArrowRotateRight';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faReceipt } from '@fortawesome/pro-light-svg-icons/faReceipt';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { faRotate } from '@fortawesome/pro-regular-svg-icons';
import Header from 'components/Checkout2/UI/Header';
import { FunctionComponent } from 'react';
import { ToolbarButton, ToolbarOption } from './UI/ToolbarButton';
import PaidTag from './PaidTag';
import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from '@emotion/react';
import { faPrint } from '@fortawesome/pro-light-svg-icons';

export interface OrderDetailHeaderProps {
    title: string;
    loading?: boolean;
    editing?: boolean;
    paid?: boolean;
    displayPaid?: boolean;
    orderClosed?: boolean;
    withoutOptions?: boolean;
    allPetsInactive?: boolean;
    onlyOnePet?: boolean;
    withoutRebook?: boolean;
    onClose?: () => void;
    onBack?: () => void;
    onEdit: () => void;
    onRebook: () => void;
    onShowLog: () => void;
    onDelete?: () => void;
    onShowInvoice?: () => void;
    onPrint?: () => void;
    className?: string;
    recurringUuid?: string;
    isRecurringSeriesOpen?: boolean;
    onOpenRecurringSeries?: (recurringUuid: string) => void;
    zIndex?: number;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paidTag: {
            marginRight: 10
        }
    })
);

export const OrderDetailHeader: FunctionComponent<OrderDetailHeaderProps> = props => {
    const classes = useStyles();

    const toolbarOptions: Array<ToolbarOption> = [
        {
            id: 'invoice',
            icon: faReceipt,
            label: 'View Invoice',
            onClick: () => !props.loading && props.onShowInvoice && props.onShowInvoice()
        },
        {
            id: 'edit',
            icon: faPencil,
            label: 'Edit Booking',
            onClick: () => !props.loading && props.onEdit()
        },
        {
            id: 'rebook',
            icon: faArrowRotateRight,
            label: 'Rebook',
            onClick: () => !props.loading && props.onRebook()
        },
        {
            id: 'log',
            icon: faClockRotateLeft,
            label: 'Activity Log',
            onClick: () => !props.loading && props.onShowLog()
        },
        {
            id: 'print',
            icon: faPrint,
            label: 'Print',
            onClick: () => !props.loading && props.onPrint && props.onPrint()
        },
        {
            id: 'edit-recurring',
            icon: faRotate,
            label: 'Edit Recurring',
            disabled: props.isRecurringSeriesOpen,
            onClick: () =>
                !props.loading &&
                !props.isRecurringSeriesOpen &&
                props.recurringUuid &&
                props.onOpenRecurringSeries &&
                props.onOpenRecurringSeries(props.recurringUuid)
        }
    ]
        .filter(option => props.onDelete || option.id !== 'delete')
        .filter(option => !props.onlyOnePet || option.id !== 'edit')
        .filter(option => !props.withoutRebook || option.id !== 'rebook')
        .filter(option => !props.orderClosed || ['rebook', 'log', 'invoice', 'edit-recurring'].includes(option.id))
        .filter(option => !props.allPetsInactive || option.id !== 'rebook')
        .filter(option => props.paid || option.id !== 'invoice')
        .filter(option => props.onPrint || option.id !== 'print')
        .filter(option => props.recurringUuid || option.id !== 'edit-recurring');

    return (
        <Header {...props}>
            {props.editing || props.loading || props.withoutOptions ? null : (
                <>
                    {props.displayPaid && <PaidTag className={classes.paidTag} />}
                    {toolbarOptions.length > 0 && (
                        <ToolbarButton
                            options={toolbarOptions}
                            zIndex={props.zIndex}
                        />
                    )}
                </>
            )}
        </Header>
    );
};

export default OrderDetailHeader;
